module.exports = __webpack_public_path__ + "media/images/athletes/1459-a982a504abf0b905145a00deabdef4a6.png";